/**
 * Weighted random selection utilities
 */

/**
 * Select random item based on weights
 * @example weightedRandom([{id: 'common', weight: 0.7}, {id: 'rare', weight: 0.3}])
 */
export function weightedRandom<T>(
  items: { id: T; weight: number }[]
): T {
  const totalWeight = items.reduce((sum, item) => sum + item.weight, 0);
  let random = Math.random() * totalWeight;

  for (const item of items) {
    random -= item.weight;
    if (random <= 0) {
      return item.id;
    }
  }

  // Fallback (shouldn't happen with valid weights)
  return items[items.length - 1].id;
}

/**
 * Roll a random number between min and max (inclusive)
 */
export function randomRange(min: number, max: number): number {
  return min + Math.random() * (max - min);
}

/**
 * Roll a random integer between min and max (inclusive)
 */
export function randomInt(min: number, max: number): number {
  return Math.floor(randomRange(min, max + 1));
}

/**
 * Random chance check (returns true if random < chance)
 * @param chance - Probability from 0 to 1
 */
export function randomChance(chance: number): boolean {
  return Math.random() < chance;
}
